import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import { Can } from "@/components/citadel/can";
import { AddOrderTemplateModal } from "@/modals/stock/add-order-template-modal";

export function OrderTemplatesMenu() {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
				>
					{t("stock.create_order_template")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddOrderTemplateModal
					onClose={disclosure.onClose}
					isOpen={disclosure.isOpen}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
